module.exports = __webpack_public_path__ + "images/no-results.52006ec7c34d1075df2a17157d514a3b.png";